import { GetAllCustomersInDto, GetAllCustomersOutDto } from '../../../types/customer.dto'

export const GET_RESPONSIBLE_CUSTOMERS = 'GET_RESPONSIBLE_CUSTOMERS'
export const GET_RESPONSIBLE_CUSTOMERS_SUCCESS = 'GET_RESPONSIBLE_CUSTOMERS_SUCCESS'
export const GET_RESPONSIBLE_CUSTOMERS_ERROR = 'GET_RESPONSIBLE_CUSTOMERS_ERROR'
export const RESET_GET_RESPONSIBLE_CUSTOMERS = 'RESET_GET_RESPONSIBLE_CUSTOMERS'

export interface GetResponsibleCustomers {
  type: typeof GET_RESPONSIBLE_CUSTOMERS
  payload: GetAllCustomersOutDto
}

export interface GetResponsibleCustomersSuccess {
  type: typeof GET_RESPONSIBLE_CUSTOMERS_SUCCESS
  payload: GetAllCustomersInDto
}

export interface GetResponsibleCustomersError {
  type: typeof GET_RESPONSIBLE_CUSTOMERS_ERROR
  payload: string | boolean
}

export interface ResetGetResponsibleCustomers {
  type: typeof RESET_GET_RESPONSIBLE_CUSTOMERS
  payload: null
}

export interface State {
  data: GetAllCustomersInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetResponsibleCustomers | GetResponsibleCustomersSuccess | GetResponsibleCustomersError | ResetGetResponsibleCustomers
